import { render } from "./SenhasTotemPanel.vue?vue&type=template&id=6cbd442c&scoped=true"
import script from "./SenhasTotemPanel.vue?vue&type=script&lang=js"
export * from "./SenhasTotemPanel.vue?vue&type=script&lang=js"

import "@/assets/css/botao-chamar.css?vue&type=style&index=0&id=6cbd442c&scoped=true&lang=css&external"
import "./SenhasTotemPanel.vue?vue&type=style&index=1&id=6cbd442c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cbd442c"]])

export default __exports__